import React, { Component } from "react";
import {getFavoriteAuthor,addFavoriteAuthor,removeFavoriteAuthor} from '../config/Variables';
export default class FollowAuthor extends Component {

  constructor() {
    super();
    this.state = {
      hobbies: [],
      tid: '',
      messagelog: '',
      isLoading: true,
      users: [],
      numberstid: [],
      error: null,
      isList:false,
    }
    this.handleInputChange = this.handleInputChange.bind(this);


    if (localStorage.getItem('user-info')) {

    let user = JSON.parse(localStorage.getItem('user-info'))
    let datt = fetch(getFavoriteAuthor, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Accept": 'application/json',
        "Authorization": "Bearer " + user.token.access_token,
      },
      body: JSON.stringify(this.state)
    }).then(response => response.json())
      .then(data => {
        if(data.webmsg.code==401){
          localStorage.clear();
          var domainurl=  window.location.origin;
          window.location.href = domainurl+'/journey';
        }
        data.data.map(({ tid }, index2) => {
          this.state.numberstid.push(tid);
          //this.setState({ numberstid: [this.state.numberstid, tid] })
          this.setState({ numberstid: this.state.numberstid })
          this.state.hobbies.push(tid);
        });
      });
  }
}
  async   handleInputChange(event) {


    const target = event.target;
    var value = target.value;

    if (event.target.checked) {
   // var tid = document.getElementById('author_tid').getAttribute('data-value');
    const isList=false;
    const element = event.target;
    let c = element.closest("div");
    var tid=c.getAttribute('data-value');

    let item = { tid,isList };
  ;

    if (tid == "") {
      this.setState({ messagelog: "اختر الكاتب المفضل لديك" });
    } else {
      if (localStorage.getItem('user-info')) {

        let user = JSON.parse(localStorage.getItem('user-info'))
        let result = await fetch(addFavoriteAuthor, {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            "Accept": 'application/json',
            "Authorization": "Bearer " + user.token.access_token,
          },
          body: JSON.stringify(item)
        });
        result = await result.json();

        if (result.message.code == '200') {
          //localStorage.setItem("user-info", JSON.stringify(result));
          //history('/add');
          this.props.samirCallback("success");
        }
      }
    }
  }else{
    //var tid = document.getElementById('author_tid').getAttribute('data-value');
    const element = event.target;
    let c = element.closest("div");
    var tid=c.getAttribute('data-value');

    let item = { tid };
    if (tid == "") {
      this.setState({ messagelog: "اختر الكاتب المفضل لديك" });
    } else {
      if (localStorage.getItem('user-info')) {

        let user = JSON.parse(localStorage.getItem('user-info'))
        let result = await fetch(removeFavoriteAuthor, {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            "Accept": 'application/json',
            "Authorization": "Bearer " + user.token.access_token,
          },
          body: JSON.stringify(item)
        });
        result = await result.json();

        if (result.message.code == '200') {
          //localStorage.setItem("user-info", JSON.stringify(result));
          //history('/add');
          this.props.samirCallback("success");
        }
      }
    }




  }
  }

  render() {
    const {
      users,
      error,
      numberstid
    } = this.state;
      if (localStorage.getItem('user-info')) {
   // var tid = document.getElementById('author_tid').getAttribute('data-value');
    var tid =this.props.nodeid;
    const fruitss = this.state.numberstid;
    const ttt = parseInt(tid);
    const ss = fruitss.includes(ttt); //true
    
    if (ss) {
    return (
      <>
        
        <input type="checkbox"  id={`select-writer-${tid}`} 
          name="authorfollow" 
          className="form-check"  defaultChecked={true} onTouchEnd={this.handleInputChange} onClick={this.handleInputChange} />

      </>
    );
  }else{
    return (
      <>     
        <input type="checkbox" id={`select-writer-${tid}`} 
          name="authorfollow" 
          className="form-check" onTouchEnd={this.handleInputChange} onClick={this.handleInputChange} />
      </>
    );
    }
  }else{
    return (
      <>     
      <input type="checkbox" id={`select-writer-${tid}`}  name="author" value="2" class="form-check modal-toggle" data-id="modal-notification" />
     </>
    );
  }
}
}
